import React, { useState } from 'react';
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/react';
import styles from './Tooltip.module.scss';

interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactElement;
  enabled?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ content, children, enabled = true }) => {
  const [open, setOpen] = useState(false);
  const { refs, floatingStyles } = useFloating({
    placement: 'top',
    middleware: [offset(6), flip(), shift({ padding: 8 })],
    whileElementsMounted: autoUpdate,
  });

  return (
    <span
      ref={refs.setReference}
      onMouseEnter={() => enabled && setOpen(true)}
      onMouseLeave={() => enabled && setOpen(false)}
      className={styles.trigger}
    >
      {children}
      {enabled && open && (
        <span ref={refs.setFloating} style={{ ...floatingStyles }}>
          <span className={styles.bubble}>{content}</span>
        </span>
      )}
    </span>
  );
};

export default Tooltip;
